import { constants } from '..';

/**
 * Given an instance of a getToken function, return a Promise that will resolve with the
 * token.
 * @param {GetToken} getToken
 */
export const getTokenPromise = (getToken: GetToken): Promise<string | null> =>
    new Promise((resolve, reject) => {
        const handleToken = (token: string): void => {
            resolve(token);
        };

        const handleTokenMissing = (): void => {
            reject(new Error(constants.CLIENT_ERROR_MESSAGES.TOKEN_MISSING));
        };

        getToken(handleToken, handleTokenMissing);
    });
